import { useWizardListener } from '@mwkt/react-magic-frame';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { hideModal } from 'state/modal/modal-reducer';

import { MagicFrameWizardEvent } from '../constants';

import useGetEmbeddedLocation from './use-get-embedded-location';

const useWizardSetRouteListener = () => {
  const history = useHistory();
  const getEmbeddedLocation = useGetEmbeddedLocation();
  const dispatch = useDispatch();

  useWizardListener({ event: MagicFrameWizardEvent.SetRoute, callback: (relativeUrl: string) => {
    const embeddedLocation = getEmbeddedLocation(relativeUrl);

    if (embeddedLocation) {
      dispatch(hideModal());
      history.push(embeddedLocation);
    }
  } });
};

export default useWizardSetRouteListener;
